import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Container, VStack, Span, Box, theme } from '@bpba/ui-components';
import styled from 'styled-components';
import { SuspenseFallback } from '../shared/components/SuspenseFallback';

export const Layout = () => {
  return (
    <PageWrapper>
      <Box background="transparent" padding={`${theme.space[8]}px 0px`} position="relative" overflow="hidden">
        <Container>
          <VStack gap={3}>
            <Span
              display="inline-block"
              fontSize={0}
              fontWeight="semibold"
              letterSpacing="1.2px"
              p={`${theme.space[1]}px ${theme.space[3]}px`}
              borderRadius="sm"
              width="fit-content"
              color="white"
              backgroundColor="tertiary.0"
            >
              COMERCIOS ADHERIDOS
            </Span>
            <HeroTitle>Préstamo Acá</HeroTitle>
            <VStack gap={1}>
              <Span as="p" fontWeight={400} fontSize={[1, 2]} color="white">
                Financiá tu próxima compra
              </Span>
            </VStack>
          </VStack>
        </Container>
      </Box>

      <Suspense fallback={<SuspenseFallback />}>
        <Outlet />
      </Suspense>
    </PageWrapper>
  );
};

// Verde de marca con tono más bajo (de #279d2e a #1f7a25): mas mate, menos saturado.
const HERO_GREEN = '#1f7a25';

const PageWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  background: `linear-gradient(180deg, ${HERO_GREEN} 0%, ${HERO_GREEN} 176px, #8fa690 204px, rgb(235, 235, 235) 249px)`,
  minHeight: '100vh',
  paddingBottom: `${theme.space[9] * 2}px`,
  overflowX: 'hidden',
});

const HeroTitle = styled.h1({
  margin: 0,
  letterSpacing: '-0.5px',
  color: theme.colors.white,
  fontFamily: theme.fonts.heading,
  fontWeight: theme.fontWeights.bold,
  fontSize: `${theme.fontSizes[9]}px`,
  lineHeight: theme.lineHeights[9],

  '@media (max-width: 1024px)': {
    fontSize: `${theme.fontSizes[8]}px`,
    lineHeight: theme.lineHeights[8],
  },

  '@media (max-width: 480px)': {
    fontSize: `${theme.fontSizes[6]}px`,
    lineHeight: theme.lineHeights[6],
  },
});
